import React from "react";
import { Alert, AlertTitle, Box } from "@mui/material";
import { useAppSelector } from "../store";
import Permission, * as Permissions from "./Permission";
import Role from "./Role";

type Props = {
  children: JSX.Element, 
  roles?: Role[],
  permissions?: Permission[],
  showBlank?: boolean,
};
export const SecureModule = (props: Props) => {
  const  { children, roles, permissions, showBlank } = props;
  const auth = useAppSelector(s => s.auth);
  if (Permissions.hasPermission(auth, roles, permissions)) return children;
  if (showBlank === true) return null;
  return (
    <Box>
      <Alert severity="error">
        <AlertTitle>UNAUTHORIZED ACCESS</AlertTitle>
        You do not have <strong>PERMISSION</strong> to access this module. Please react out to administrator to provide you and access.
      </Alert>
    </Box>
  );
};
